import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function RedefinirSenha() {
  const [senha, setSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [erro, setErro] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  // Extrai o token da URL
  const params = new URLSearchParams(location.search);
  const token = params.get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMensagem('');
    setErro('');
    if (!senha || !confirmarSenha) {
      setErro('Preencha todos os campos.');
      return;
    }
    if (senha !== confirmarSenha) {
      setErro('As senhas não coincidem.');
      return;
    }
    try {
      const response = await fetch('https://sismoney.com/painel/redefinir-senha.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: `token=${encodeURIComponent(token)}&senha=${encodeURIComponent(senha)}`,
      });
      const text = await response.text();
      if (text.includes('sucesso')) {
        setMensagem('Senha redefinida com sucesso! Você já pode fazer login.');
        setTimeout(() => navigate('/login'), 2000);
      } else {
        setErro('Token inválido, expirado ou erro ao redefinir senha.');
      }
    } catch (err) {
      setErro('Erro ao conectar ao servidor.');
    }
  };

  if (!token) {
    return <div className="min-h-screen flex items-center justify-center text-red-600 font-bold">Token inválido!</div>;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl max-w-md w-full p-8 space-y-8">
        <h2 className="text-2xl font-bold text-center text-gray-900 dark:text-white mb-4">Redefinir Senha</h2>
        {mensagem && <div className="text-green-600 text-center text-sm">{mensagem}</div>}
        {erro && <div className="text-red-500 text-center text-sm">{erro}</div>}
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Nova senha</label>
            <input
              type="password"
              value={senha}
              onChange={e => setSenha(e.target.value)}
              className="block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-700 dark:text-white"
              placeholder="Digite a nova senha"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Confirmar nova senha</label>
            <input
              type="password"
              value={confirmarSenha}
              onChange={e => setConfirmarSenha(e.target.value)}
              className="block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-700 dark:text-white"
              placeholder="Confirme a nova senha"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full flex items-center justify-center px-4 py-2 border border-transparent text-base font-medium rounded-lg text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
          >
            Redefinir Senha
          </button>
        </form>
      </div>
    </div>
  );
}
